import React, { useState } from "react";
import { Typography, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../components/Alert";
import { CustomChartsTitle } from "../../components/Custom/CustomTypography";
import CustomButton from "../../components/Custom/CustomButton";
import FileUpload from "../../components/Custom/FileUpload";

export default function AddCSV() {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const { showAlert } = useAlert();

  const handleDownloadTemplateSample = async () => {
    try {
      const response = await api.get(
        "/buyer/download-requirement-template-sample/",
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "requirement_sample.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading CSV:", error);
      alert("Failed to download CSV. Please try again later.");
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      const response = await api.get("/buyer/download-requirement-template/", {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "requirement_template.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading CSV:", error);
      alert("Failed to download CSV. Please try again later.");
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUploadCSV = () => {
    if (!file) {
      showAlert("error", "Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    showAlert(
      "success",
      "Uploading and processing the CSV, it may take some time to reflect the requirements"
    );

    api
      .post("/buyer/upload-requirement-csv/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("CSV uploaded successfully:", response.data);
        showAlert("success", "CSV Uploaded Successfully");
        setFile(null);
        window.location.href = "/";
      })
      .catch((error) => {
        console.error("Error uploading CSV:", error);
        showAlert("error", "Error uploading CSV");
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container
        maxWidth="xs"
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontSize: "30px",
            fontWeight: 700,
            marginTop: "10px",
          }}
        >
          {t("Requirement CSV")}
        </Typography>

        <Box>
          <Box mt={1}>
            <CustomChartsTitle>
              {t("Download Excel Dummy File with Commodity List")}
            </CustomChartsTitle>
            <CustomButton onClick={handleDownloadTemplateSample} hideIcon>
              {t("Download Sample")}
            </CustomButton>
          </Box>

          <Box mt={5}>
            <CustomChartsTitle>
              {t("Download Editable Excel File")}
            </CustomChartsTitle>
            <CustomButton onClick={handleDownloadTemplate} hideIcon>
              {t("Download Template")}
            </CustomButton>
          </Box>

          <Box mt={5}>
            <CustomChartsTitle>
              {t("Upload Excel File to create Requirements")}
            </CustomChartsTitle>

            <FileUpload
              label="Requirements CSV File"
              onChange={handleFileChange}
              name="csvFile"
              accept=".csv"
              hideSubtext
            />

            <CustomButton onClick={handleUploadCSV} hideIcon>
              {t("Upload CSV")}
            </CustomButton>
          </Box>
        </Box>
      </Container>
    </>
  );
}
